import { render, staticRenderFns } from "./PortalSelectField.vue?vue&type=template&id=695dd584&scoped=true&"
import script from "./PortalSelectField.vue?vue&type=script&lang=js&"
export * from "./PortalSelectField.vue?vue&type=script&lang=js&"
import style0 from "./PortalSelectField.vue?vue&type=style&index=0&id=695dd584&scoped=true&lang=scss&"
import style1 from "./PortalSelectField.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695dd584",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('695dd584')) {
      api.createRecord('695dd584', component.options)
    } else {
      api.reload('695dd584', component.options)
    }
    module.hot.accept("./PortalSelectField.vue?vue&type=template&id=695dd584&scoped=true&", function () {
      api.rerender('695dd584', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/filters/PortalSelectField.vue"
export default component.exports